import React, { createContext, useContext, useEffect, useState } from 'react';

const SelectableContext = createContext();

export const useSelectableContext = () => {
    return useContext(SelectableContext);
};

export const Provider = ({ children, selected: initiallySelected, enabled = false }) => {
    const [isSelecting, setIsSelecting] = useState(!!enabled)
    const [selected, setSelected] = useState(initiallySelected ?? []);
    const [allSelectable, setAllSelectable] = useState([]);
    const [allSelected, setAllSelected] = useState(false);

    useEffect(() => {
        if (allSelectable.length > 0 && allSelectable.length === selected.length) {
            setAllSelected(true);
        } else {
            setAllSelected(false);
        }
    }, [allSelectable, selected]);

    const toggleSelected = (id) => {
        if (selected.includes(id)) {
            setSelected(selected.filter((i) => i !== id));
        } else {
            setSelected([...selected, id]);
        }
    }

    const select = (id) => {
        if (!selected.includes(id)) {
            setSelected([...selected, id]);
        }
    }

    const deselect = (id) => {
        if (selected.includes(id)) {
            setSelected(selected.filter((i) => i !== id));
        }
    }

    const selectNone = () => {
        setSelected([]);
    }

    const isSelected = (id) => {
        return selected.includes(id);
    }

    const toggleIsSelecting = () => {
        setIsSelecting(is => !is);
    }

    const addSelectable = (id) => {
        setAllSelectable(allS => {
            if (allS.includes(id)) {
                return allS;
            }
            return [...allS, id];
        })
    }

    const replaceSelectable = (ids) => {
        setAllSelectable(ids);
    }

    const toggleAllSelected = () => {
        if (allSelected) {
            setSelected([]);
            setAllSelected(false);
        } else {
            setSelected(allSelectable);
            setAllSelected(true);
        }
    }

    const providerValues = {
        selected,
        toggleSelected,
        select,
        deselect,
        selectNone,
        isSelected,
        isSelecting,
        setIsSelecting,
        toggleIsSelecting,
        addSelectable,
        replaceSelectable,
        allSelected,
        toggleAllSelected,
    };

    return (
        <SelectableContext.Provider value={providerValues}>
            {children}
        </SelectableContext.Provider>
    );
};
